import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import './Clientes.css';

// Importa el componente del cliente
import Nazareth from './clientes/Nazareth';
import Residencia from './clientes/Residencia';
import CasaArzobispal from './clientes/CasaArzobispal';
import Capilla from './clientes/Capilla';
import SeminarioMayor from './clientes/SeminarioMayor';
import Seminario from './clientes/Seminario';
import Humilladero from './clientes/Humilladero';
import PortalBosque from './clientes/Zona-Residencial';
import HotelDancar from './clientes/Hotel-Dancar';
import Coomultrup from './clientes/Coomultrup';
import CoomultrupOficinas from './clientes/CoomultrupOficinas';
import CasaDeLasMedias from './clientes/Casa_De_Las_Medias';
import LasNieves from './clientes/Las Nieves';
import ParroquiaToledo from './clientes/ParroquiaToledo';
import MasseClub from './clientes/MasseClub';
import HumbertoParada from './clientes/HumbertoParada';
import ParroquiaChinacota from './clientes/ParroquiaChinacota';
import HotelHyR from './clientes/HotelHyR';
import Convento from './clientes/Convento';
import ElCarmen from './clientes/ElCarmen';
import SanAndresito from './clientes/SanAndresito';
const Clientes = ({ clienteId, setIsModalOpen }) => {
  // 👉 AÑADIDO PARA ACTIVAR SCROLL SOLO AQUÍ
  useEffect(() => {
    document.body.classList.add('clientes');
    document.documentElement.classList.add('clientes');

    return () => {
      document.body.classList.remove('clientes');
      document.documentElement.classList.remove('clientes');
    };
  }, []);
  // 👉 FIN CAMBIO

  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const [cards] = useState([
    {
      id: 1,
      slug: 'casa-de-nazareth',
      title: 'Casa de Nazareth',
      content: 'Instalación satisfactoria y rentable',
      background: require('../assets/nazareth_1.avif'),
      image: require('../assets/CasaNazareth.avif'),
    },

    {
      id: 2,
      slug: 'Parroquia-Toledo',
      title: 'Toledo: Parroquia San Luis Gonzaga',
      content: 'Intalación de Sistema Fotovoltaico',
      image: require('./clientes/assets/ParroquiaToledo/Tarjeta.png'),
      background: require('./clientes/assets/ParroquiaToledo/Fondo.png'),
      backgroundMobile: require('./clientes/assets/ParroquiaToledo/FondoCel.png'),
    },

    {
      id: 3,
      slug: 'Parroquia-Chinacota',
      title: 'Chinacota: Parroquia San Juan Bautista de Chinácota',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/ParroquiaChinacota/Tarjeta.png'),
      background: require('./clientes/assets/ParroquiaChinacota/Fondo.png'),
      backgroundMobile: require('./clientes/assets/ParroquiaChinacota/FondoCel.png'),
    },

    {
      id: 4,
      slug: 'Masse Club',
      title: 'Masse Club',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/MasseClub/Tarjeta.png'),
      background: require('./clientes/assets/MasseClub/Fondo.png'),
      backgroundMobile: require('./clientes/assets/MasseClub/FondoCel.png'),
    },

    {
      id: 5,
      slug: 'seminario-mayor',
      title: 'Seminario Mayor',
      content:
        'Instalacion de varias cadenas de paneles solares en diferentes áreas del techo del Seminario Mayor',
      image: require('../assets/seminarioMa.png'),
      background: require('./clientes/assets/Seminario_Mayor/fondoSemMa.png'),
    },

    {
      id: 6,
      slug: 'Hotel HyR',
      title: 'Hotel H&R',
      content: 'Instalacion de Sistema Fotovoltaico y Termosolar',
      image: require('./clientes/assets/HotelHyR/Tarjeta.png'),
      background: require('./clientes/assets/HotelHyR/Fondo.png'),
      backgroundMobile: require('./clientes/assets/HotelHyR/FondoCel.png'),
    },

    {
      id: 7,
      slug: 'casa-de-las-medias',
      title: 'Casa de las Medias',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/Casa_De_Las_Medias/Tarjeta.png'),
      background: require('./clientes/assets/Casa_De_Las_Medias/fondo.png'),
    },

    {
      id: 8,
      slug: 'seminario-menor',
      title: 'Seminario Menor',
      content: 'Instalación de sistemas fotovoltaicos',
      image: require('./clientes/assets/Seminario/Tar_Seminario.jpg'),
      background: require('../components/clientes/assets/Seminario/Paneles_Seminario.jpeg'),
    },
    {
      id: 9,
      slug: 'humilladero',
      title: 'Señor del Humilladero',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/Humilladero/fachada.png'),
      background: require('../components/clientes/assets/Humilladero/image.png'),
    },
    {
      id: 10,
      slug: 'PortalBosque',
      title: 'Portal El Bosque',
      content: 'Instalación de sistemas solares',
      image: require('./clientes/assets/Zona_Residencial/Portada_Residencial.PNG'),
      background: require('../components/clientes/assets/Zona_Residencial/fondo.png'),
    },
    {
      id: 11,
      slug: 'HotelDancar',
      title: 'Hotel Dancar',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/HotelDancar/tarjeta.png'),
      background: require('./clientes/assets/HotelDancar/fondo.png'),
      backgroundMobile: require('./clientes/assets/HotelDancar/FondoCel.png'),
    },
    {
      id: 12,
      slug: 'Coomultrup-Supermercado',
      title: 'Coomultrup: Supermercado',
      content: 'Intalación de sistema fotovoltaico',
      image: require('./clientes/assets/Coomultrup/cardcomultrup.jpg'),
      background: require('./clientes/assets/Coomultrup/fondo.png'),
    },

    {
      id: 13,
      slug: 'Coomultrup-Oficinas',
      title: 'Coomultrup: Oficinas',
      content: 'Intalación de sistema fotovoltaico',
      image: require('./clientes/assets/CoomultrupOficinas/Tarjeta.png'),
      background: require('./clientes/assets/CoomultrupOficinas/Fondo.png'),
      backgroundMobile: require('./clientes/assets/CoomultrupOficinas/FondoCel.png'),
    },

    {
      id: 14,
      slug: 'Las_Nieves',
      title: 'Casa Cural Las Nieves',
      content: 'Intalación de sistema fotovoltaico',
      image: require('./clientes/assets/Las_Nieves/Tarjeta.png'),
      background: require('./clientes/assets/Las_Nieves/Fondo.png'),
    },
    {
      id: 15,
      slug: 'casa-particular',
      title: 'Residencia Las Colinas',
      content: 'Instalación a nivel doméstico',
      image: require('./clientes/assets/ResidencialColinas/Tarjeta.png'),
      background: require('./clientes/assets/ResidencialColinas/Fondo.png'),
      /*imageMobile: require('../assets/CASA.avif'),*/
      backgroundMobile: require('../assets/CASA.avif'),
    },
    {
      id: 16,
      slug: 'capilla-san-pedro',
      title: 'Capilla San Pedro',
      content:
        'Instalación en la capilla nuestra señora de Guadalupe del barrio San Pedro',
      image: require('../assets/Capilla.png'),
      background: require('../assets/Zonaurbana.avif'),
    },
    {
      id: 17,
      slug: 'Humberto-Parada',
      title: 'Residencia: Humberto Parada',
      content: 'Instalación Sistema Fotovoltaico en residencia Humberto Parada',
      image: require('./clientes/assets/HumbertoParada/Tarjeta.png'),
      background: require('./clientes/assets/HumbertoParada/Fondo.png'),
    },

    {
      id: 18,
      slug: 'palacio-arzobispal',
      title: 'Palacio Arzobispal',
      content: 'Instalación de sistema fotovoltaico',
      image: require('../assets/Palacio.png'),
      background: require('../assets/casa-arsobispal.avif'),
    },

    {
      id: 19,
      slug: 'convento',
      title: 'Convento',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/Convento/Tarjeta.png'),
      background: require('./clientes/assets/Convento/Fondo.png'),
      backgroundMobile: require('./clientes/assets/Convento/FondoCel.png'),
    },
    {
      id: 20,
      slug: 'el-carmen',
      title: 'El Carmen',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/ElCarmen/Tarjeta.png'),
      background: require('./clientes/assets/ElCarmen/Fondo.png'),
      backgroundMobile: require('./clientes/assets/ElCarmen/FondoCel.png'),
    },

     {
      id: 21,
      slug: 'sanandresito',
      title: 'Sanandresito',
      content: 'Instalación de sistema fotovoltaico',
      image: require('./clientes/assets/SanAndresito/Tarjeta.png'),
      background: require('./clientes/assets/SanAndresito/Fondo.png'),
      backgroundMobile: require('./clientes/assets/SanAndresito/FondoCel.png'),
    },



  ]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkSize(); // ejecuta al cargar
    window.addEventListener('resize', checkSize);

    return () => window.removeEventListener('resize', checkSize);
  }, []);

  const carouselRef = useRef(null);

  const setBackgroundImage = useCallback(
    (card) => {
      const backgroundElement = document.querySelector('.background');
      if (!backgroundElement) return;

      const imageUrl =
        isMobile && card?.backgroundMobile
          ? card.backgroundMobile
          : (card?.background ?? card?.image);

      backgroundElement.style.backgroundImage = `url(${imageUrl})`;
    },
    [isMobile]
  );

  // Sincroniza si la ruta trae un índice numérico
  useEffect(() => {
    if (!clienteId) return;
    const parsedIndex = Number.parseInt(clienteId, 10);

    if (
      !Number.isNaN(parsedIndex) &&
      parsedIndex >= 0 &&
      parsedIndex < cards.length
    ) {
      setCurrentIndex(parsedIndex);
      setShowModal(false);
    }
  }, [clienteId, cards.length]);

  useEffect(() => {
    setBackgroundImage(cards[currentIndex]);
  }, [currentIndex, cards, setBackgroundImage, isMobile]);

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;

    requestAnimationFrame(() => {
      const el = container.children[currentIndex];
      if (!el) return;

      const styles = getComputedStyle(container);
      const padLeft = parseFloat(styles.paddingLeft) || 0;
      const padRight = parseFloat(styles.paddingRight) || 0;

      const cardWidth = el.offsetWidth;
      const containerWidth = container.clientWidth;

      // Centro ideal considerando el padding interno
      const desired =
        el.offsetLeft - // ya incluye padLeft en el offset
        (containerWidth - padLeft - padRight) / 2 +
        cardWidth / 2;

      const maxScroll = Math.max(
        0,
        container.scrollWidth - container.clientWidth
      );
      const clamped = Math.min(Math.max(desired, 0), maxScroll);

      container.scrollTo({ left: clamped, behavior: 'smooth' });
    });
  }, [currentIndex]);

  const handleNavigation = useCallback(
    (newIndex) => {
      if (newIndex === currentIndex) return;
      const url = showModal
        ? `/clientes/${cards[newIndex].slug}`
        : `/clientes/${newIndex}`;
      navigate(url, { replace: false });
    },
    [currentIndex, showModal, cards, navigate]
  );

  const handleCardClick = (index) => {
    // Si el usuario hace clic en la misma tarjeta activa
    if (index === currentIndex) {
      setShowModal(true);
      setIsModalOpen?.(true);
      const slug = cards[index].slug;
      navigate(`/clientes/${slug}`);
    } else {
      // Si es una tarjeta diferente, solo navega normalmente
      handleNavigation(index);
    }
  };

  const handleDotClick = (index) => handleNavigation(index);
  const handleIndicatorArrowClick = (direction) => {
    const newIndex = (currentIndex + direction + cards.length) % cards.length;
    handleNavigation(newIndex);
  };

  const handleVerProyectoClick = () => {
    setShowModal(true);
    setIsModalOpen?.(true); // ← Notifica al swipe que se desactive
    const slug = cards[currentIndex].slug;
    navigate(`/clientes/${slug}`);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsModalOpen?.(false); // ← Notifica al swipe que se reactive
    navigate(`/clientes/${currentIndex}`);
  };

  const clientComponents = {
    'Casa de Nazareth': <Nazareth />,
    'Residencia Las Colinas': <Residencia />,
    'Palacio Arzobispal': <CasaArzobispal />,
    'Capilla San Pedro': <Capilla />,
    'Seminario Mayor': <SeminarioMayor />,
    'Seminario Menor': <Seminario />,
    'Señor del Humilladero': <Humilladero />,
    'Portal El Bosque': <PortalBosque />,
    'Hotel Dancar': <HotelDancar />,
    'Casa de las Medias': <CasaDeLasMedias />,
    'Coomultrup: Supermercado': <Coomultrup />,
    'Coomultrup: Oficinas': <CoomultrupOficinas />,
    'Casa Cural Las Nieves': <LasNieves />,
    'Toledo: Parroquia San Luis Gonzaga': <ParroquiaToledo />,
    'Masse Club': <MasseClub />,
    'Residencia: Humberto Parada': <HumbertoParada />,
    'Chinacota: Parroquia San Juan Bautista de Chinácota':  <ParroquiaChinacota />,
    'Hotel H&R': <HotelHyR />,
    'Convento': <Convento />,
    'El Carmen': <ElCarmen />,
    'Sanandresito': <SanAndresito/>,
  };

  const clienteComponent = clientComponents[cards[currentIndex]?.title];

  // Sincroniza cuando la ruta trae un slug
  useEffect(() => {
    if (!clienteId) return;
    const slugIndex = cards.findIndex((card) => card.slug === clienteId);
    if (slugIndex !== -1) {
      setCurrentIndex(slugIndex);
      setShowModal(true);
      setIsModalOpen?.(true);
    }
  }, [clienteId, cards, setIsModalOpen]);

  return (
    <section id="clientes" className="clientes-section">
      <Helmet>
        {/* Meta SEO general */}
        <title>{cards[currentIndex].title} | Clientes | Ipsum</title>
        <meta
          name="description"
          content={`Proyecto destacado: ${cards[currentIndex].title} - ${cards[currentIndex].content}. Sistemas fotovoltaicos y soluciones solares de Ipsum Ingeniería.`}
        />
        <meta
          name="keywords"
          content={`clientes, instalaciones solares, energía renovable, paneles solares, sistemas fotovoltaicos, Ipsum Ingeniería, ${cards[currentIndex].title}, Norte de Santander, Cúcuta`}
        />
        <meta name="robots" content="index, follow" />
        {/* Open Graph */}
        <meta
          property="og:title"
          content={`${cards[currentIndex].title} | Ipsum Ingeniería`}
        />
        <meta property="og:description" content={cards[currentIndex].content} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://www.ipsumiei.com.co/clientes/${cards[
            currentIndex
          ].title
            .toLowerCase()
            .replace(/\s+/g, '-')}`}
        />
        <meta property="og:image" content={cards[currentIndex].image} />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`${cards[currentIndex].title} | Ipsum Ingeniería`}
        />
        <meta
          name="twitter:description"
          content={cards[currentIndex].content}
        />
        <meta name="twitter:image" content={cards[currentIndex].image} />
      </Helmet>

      <div className="background-overlay" />
      <div className="background" />

      <div className={`background-text active`}>
        <h2>{cards[currentIndex].title}</h2>
        <p>{cards[currentIndex].content}</p>
        <button className="ver-proyecto-btn" onClick={handleVerProyectoClick}>
          VER PROYECTO{' '}
          <svg viewBox="0 0 180 45" preserveAspectRatio="none">
            <rect x="0" y="0" width="180" height="45"></rect>
          </svg>
        </button>
      </div>

      <div
        className="indicator-arrow-i"
        onClick={() => handleIndicatorArrowClick(-1)}
      >
        ‹
      </div>

      <div className="carousel-wrapper">
        <div
          className="card-carousel carousel-container"
          ref={carouselRef}
          onTouchStart={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          {cards.map((card, index) => (
            <div
              key={card.id}
              className={`card ${index === currentIndex ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${
                  isMobile && card.imageMobile ? card.imageMobile : card.image
                })`,
              }}
              onClick={() => handleCardClick(index)}
            >
              <h2>{card.title}</h2>
            </div>
          ))}
        </div>

        {/* Mantén las flechas solo aquí */}
        <div className="indicators-container">
          <div
            className="indicator-arrow"
            onClick={() => handleIndicatorArrowClick(-1)}
          >
            ‹
          </div>

          {cards.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}

          <div
            className="indicator-arrow"
            onClick={() => handleIndicatorArrowClick(1)}
          >
            ›
          </div>
        </div>
      </div>

      <div
        className="indicator-arrow-d"
        onClick={() => handleIndicatorArrowClick(1)}
      >
        ›
      </div>

      {showModal && (
        <div className="cliente-modal-overlay modal-container">
          <div className="cliente-modal">
            <button className="close-button" onClick={handleCloseModal}>
              ×
            </button>

            {clienteComponent || (
              <>
                <h2>{cards[currentIndex]?.title}</h2>
                <img
                  style={{
                    height: '80%',
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                  src={cards[currentIndex]?.image}
                  alt={cards[currentIndex]?.title}
                />
                <p>{cards[currentIndex]?.content}</p>
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Clientes;
